<template>
  <div class="custom-select-container">
    <p class="custom-select-container__label">{{ label }}</p>
    <div class="custom-select" v-clickoutside="closeDropdown">
      <button
        aria-haspopup="listbox"
        class="custom-select__selected"
        @click="open = !open"
      >
        {{ checkedOptionLabel }}
        <span class="select-chevron-icon">
          <slot name="chevronIcon"></slot>
        </span>
      </button>
      <div class="custom-select-dropdown" :class="{ hide: !open }">
        <ul role="listbox">
          <li
            tabindex="0"
            class="custom-select-dropdown__option"
            v-for="option in options"
            :key="option.value"
            @click="setOption(option)"
            @keyup.enter="setOption(option)"
            role="option"
          >
            {{ option.label }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { clickoutside } from "@Foundation/directives/clickoutside/clickoutside";

  export default {
    name: "custom-select",
    directives: {
      clickoutside,
    },
    props: {
      options: {
        type: Array,
        required: true,
      },
      label: {
        type: String,
        default: "SORT BY",
      },
    },

    data() {
      return {
        open: false,
        checkedOptionLabel: this.label,
      };
    },

    mounted() {
      const selectedOption = this.options.find((option) => option.checked);
      if (selectedOption) {
        this.setOption(selectedOption);
      }
    },

    methods: {
      setOption: function (selectedOption) {
        this.options.forEach((option) => {
          if (option == selectedOption) {
            option.checked = true;
            this.checkedOptionLabel = option.label;
          } else {
            option.checked = false;
          }
        });
        this.open = false;
        this.$emit("option-changed", this.options);
      },

      closeDropdown: function () {
        this.open = false;
      },
    },
  };
</script>

<style src="./CustomSelect.scss" lang="scss"></style>
